import { Input } from "@/components/ui/input";
import { Search, X } from "lucide-react";

export default function FilterBar({ search, onSearch, onClear, activeCount, children }) {
    // Default active count = search alone, unless caller supplies their own count.
    const count = typeof activeCount === "number" ? activeCount : (search ? 1 : 0);
    const showClear = count > 0;

    const handleClear = () => {
        if (typeof onSearch === "function") onSearch("");
        if (typeof onClear === "function") onClear();
    };

    return (
        <div className="filter-bar flex items-center gap-2 flex-wrap mb-3">
            {onSearch !== undefined && (
                <div className="relative flex-1 min-w-[220px] max-w-[360px]">
                    <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-muted-foreground" strokeWidth={1.5} />
                    <Input
                        placeholder="> search…"
                        value={search}
                        onChange={(e) => onSearch(e.target.value)}
                        className="pl-9 h-9 font-mono text-[12.5px]"
                        style={{ borderRadius: 2 }}
                        data-testid="filter-search"
                    />
                </div>
            )}
            {children}
            {showClear && (
                <button
                    type="button"
                    onClick={handleClear}
                    data-testid="filter-clear"
                    title="Clear all filters"
                    className="filter-clear-btn ml-auto inline-flex items-center gap-1.5 h-9 px-3 text-[12px] font-medium text-muted-foreground hover:text-foreground border border-border hover:border-foreground bg-background transition-colors"
                    style={{ borderRadius: 2 }}
                >
                    <X className="w-3.5 h-3.5" strokeWidth={1.8} />
                    <span>Clear filters</span>
                    <span
                        data-testid="filter-clear-badge"
                        className="inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 ml-0.5 text-[10.5px] font-bold tabular-nums text-background bg-foreground"
                        style={{ borderRadius: 2 }}
                    >
                        {count}
                    </span>
                </button>
            )}
        </div>
    );
}
